import styled from 'styled-components'

const CheckBoxWrapper = styled.div<{ withLabel?: boolean }>`
  height: ${(p) => (p.withLabel ? 55 : 35)}px;
`

const VisibilityBox = styled.span<{ $visible: boolean }>`
  display: ${(p) => (p.$visible ? 'inline' : 'none')};
`

const AddButton = styled.div`
  margin-bottom: 20px;
`

export const s = { CheckBoxWrapper, VisibilityBox, AddButton }
